export default function AppSection() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="app" className="py-16 md:py-24 bg-white">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 rounded-3xl overflow-hidden">
            <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-16 p-8 md:p-16">
              <div className="flex-1 text-center lg:text-left">
                <h2 className="text-2xl md:text-3xl font-black text-white mb-4">移动观影</h2>
                <p className="text-sm md:text-base text-gray-400 leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
                  90影视移动端已全面优化，支持手机浏览器直接访问。
                  高清画质自适应，流量播放也流畅。随时随地，想追就追。
                </p>
                <ul className="space-y-3 mb-8 max-w-sm mx-auto lg:mx-0">
                  {[
                    '支持手势控制音量与亮度调节',
                    '智能记忆播放进度，断点续看',
                    '投屏功能支持，大屏观影更过瘾',
                  ].map((feat, idx) => (
                    <li key={idx} className="flex items-center gap-2 text-sm text-gray-300">
                      <i className="ri-checkbox-circle-fill text-green-500 text-sm w-4 h-4 flex items-center justify-center shrink-0"></i>
                      {feat}
                    </li>
                  ))}
                </ul>
                <a
                  href="#hero"
                  onClick={(e) => handleNavClick(e, '#hero')}
                  className="inline-flex items-center gap-2 px-8 py-3.5 bg-brand-600 text-white font-semibold rounded-full hover:bg-brand-700 transition-all duration-200 cursor-pointer no-underline whitespace-nowrap text-sm"
                >
                  <i className="ri-smartphone-line text-lg w-5 h-5 flex items-center justify-center"></i>
                  立即体验移动端
                </a>
              </div>
              <div className="flex-1 flex justify-center">
                <div className="relative w-64 md:w-72">
                  <div className="aspect-[9/16] rounded-2xl overflow-hidden bg-gray-800 border-4 border-gray-700 shadow-2xl">
                    <img
                      src="https://readdy.ai/api/search-image?query=Modern%20mobile%20app%20screen%20mockup%20showing%20a%20video%20streaming%20interface%20with%20movie%20thumbnails%20in%20a%20grid%20layout%2C%20dark%20theme%20UI%20design%2C%20clean%20minimal%20interface%20with%20warm%20accent%20colors%2C%20content%20discovery%20screen%20design%2C%20professional%20app%20UI%20mockup&width=360&height=640&seq=app-mockup-01&orientation=portrait"
                      alt="90影视移动端界面预览"
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}